import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSwatchbook} from '@fortawesome/free-solid-svg-icons'
import { faWandMagicSparkles} from '@fortawesome/free-solid-svg-icons'
import { faPassport} from '@fortawesome/free-solid-svg-icons'
import { faCircleInfo} from '@fortawesome/free-solid-svg-icons'
import { faClipboard} from '@fortawesome/free-solid-svg-icons'

export const  SidebarData = [
    {
        title: "Issued Credentials",
        icon: <FontAwesomeIcon icon={faSwatchbook} />,
        link: "dashboard"
    },{
        title: "Issue Credential",
        icon: <FontAwesomeIcon icon={faWandMagicSparkles} />,
        link: "create_credential"
    },
    {
        title: "Add credential template",
        icon: <FontAwesomeIcon icon={faWandMagicSparkles} />,
        link: "add_issuance"
    },
    {
        title: "Account settings",
        icon: <FontAwesomeIcon icon={faWandMagicSparkles} />,
        link: "settings"
    },

    /*{
        title: "Create template",
        icon: <FontAwesomeIcon icon={faWandMagicSparkles} />,
        link: "create_template"
    },
    {
        title: "Create schema",
        icon: <FontAwesomeIcon icon={faWandMagicSparkles} />,
        link: "create_schema"
    },
    {
        title: "Api keys",
        icon: <FontAwesomeIcon icon={faWandMagicSparkles} />,
        link: "api_key"
    },
    {
        title: "Key management",
        icon: <FontAwesomeIcon icon={faWandMagicSparkles} />,
        link: "key_management"
    },
    {
        title: "About",
        icon: <FontAwesomeIcon icon={faCircleInfo} />,
        link: "about"
    }*/
]

export const  SidebarUser = [
    /*{
        title: "Notifications",
        icon: <FontAwesomeIcon icon={faClipboard} />,
        link: "notifications"
    },*/{
        title: "Create ghost brand",
        icon: <FontAwesomeIcon icon={faClipboard} />,
        link: "create_ghost"
    }
]
